module.exports = __webpack_public_path__ + "static/media/ico-whatsapp-white.e8594bb3.svg";